<button [disabled]="disabled" class="button {{ size ? size : '' }} {{ color ? color : '' }} {{ cssClass }}">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    {{ title }}
</button>
